export enum Roles {
  Admin = "admin",
  CustomerService = "customerservice",
  SalesRep = "rep",
  SalesManager = "salesmanager",
  RetailerLevel1 = "retailer1",
  Basic = "basic",
  Unverified = "unverified",
  Removed = "removed"
}
